import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';

import { AppSettingsService, Authorized, AuthService, ClaimsService, EndpointsService, FilterService, LoginAuthorized, MenuService, StorageService, TokenService, NotificationService, NumberFormatService, FormHelperService } from './services';
import { LastUpdateBroadcaster } from './broadcasts/last-updated-broadcaster';
import { CustomHttp } from './custom-http';
import { UnauthorizedComponent } from './unauthorized.component';
import { AutoLoginComponent } from './auto-login.component';
import { BrowserService } from "./services/browser.service";
import { ObjectFactoryService } from './services/object-factory.service';
import { LogoutService } from './services/logout.service';

@NgModule({
  imports: [
    HttpModule
  ],
  providers: [
    AppSettingsService,
    Authorized,
    AuthService,
    ClaimsService,
    LogoutService,  
    EndpointsService,
    FilterService,
    LoginAuthorized,
    MenuService,
    StorageService,
    TokenService,
    CustomHttp,
    LastUpdateBroadcaster,
    NotificationService,
    NumberFormatService,
    FormHelperService,
    BrowserService,
    ObjectFactoryService
  ],
  declarations: [
    UnauthorizedComponent,
    AutoLoginComponent
  ],
  exports: [
    UnauthorizedComponent,
    AutoLoginComponent
  ]
})
export class CoreModule { }


// WEBPACK FOOTER //
// ./src/app/core/core.module.ts